import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // Dark mode is permanently disabled
  const darkMode = false;
  const setDarkMode = () => {}; // No-op function
  const toggleDarkMode = () => {}; // No-op function

  useEffect(() => {
    document.documentElement.classList.remove('dark');
    try { localStorage.removeItem('ff_dark_mode'); } catch (e) {}
  }, []);

  return (
    <ThemeContext.Provider value={{ darkMode, setDarkMode, toggleDarkMode }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
